module.exports = __webpack_public_path__ + "img/logo-pinterest.aec01a14.svg";